<template>
    <div>
        <div v-for="index in numberOfTimelines" :key="index" class="timeline-sidebar-wrapper">
            <div v-show="showRow(index)" class="timeline-sidebar-item">
                <div class="animated-background">
                    <div :style="styles" class="background-masker header-top"></div>
                    <div :style="styles" class="background-masker header-bottom"></div>
                </div>
            </div>

            <div v-show="showRow(index + index)" class="timeline-sidebar-item">
                <div class="animated-background">
                    <div :style="styles" class="background-masker header-top"></div>
                    <div :style="styles" class="background-masker end-checkbox"></div>
                    <div :style="styles" class="background-masker header-bottom"></div>
                </div>
            </div>

            <div v-show="showRow(index + index * 2)" class="timeline-sidebar-item">
                <div class="animated-background">
                    <div :style="styles" class="background-masker header-top"></div>
                    <div :style="styles" class="background-masker header-bottom"></div>
                </div>
            </div>

            <div v-show="showRow(index + index * 3)" class="timeline-sidebar-item">
                <div class="animated-background">
                    <div :style="styles" class="background-masker header-top"></div>
                    <div :style="styles" class="background-masker header-bottom"></div>
                </div>
            </div>

            <div v-show="showRow(index + index * 4)" class="timeline-sidebar-item">
                <div class="animated-background">
                    <div :style="styles" class="background-masker header-top"></div>
                    <div :style="styles" class="background-masker header-bottom"></div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import '@/styles/general/timeline-sidebar.scss'

const TIMELINE_BLOCK_HEIGHT = 150

export default {
    name: 'TimelineSidebar',
    data() {
        return {
            screenHeight: 0,
            rowHeight: 30,
        }
    },
    computed: {
        numberOfTimelines: vm => Math.floor(vm.screenHeight / TIMELINE_BLOCK_HEIGHT),
        maxCountRow: vm => Math.floor(vm.screenHeight / vm.rowHeight),
        showRow: vm => index => index < vm.maxCountRow,
        styles: vm => {
            return {
                background: `#${vm.background}`
            }
        }
    },
    mounted() {
        this.updateScreenHeight();
        window.addEventListener('resize', this.updateScreenHeight);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateScreenHeight);
    },
    methods: {
        updateScreenHeight() {
            this.screenHeight = this.$parent.$refs?.[this.refParent]?.clientHeight || this.height || TIMELINE_BLOCK_HEIGHT;
        },
    },
    props: {
        refParent: {
            type: String,
            default: 'listContent'
        },
        background: {
            type: String,
            default: 'fff'
        },
        height: {
            type: Number,
            default: 0
        }
    }
}
</script>
